import React from 'react';

const AuthLayout = ({ children }) => {
    return (
        <div className="auth-layout">
            <main>{children}</main> {/* This will render the routes here */}
        </div>
    );
};

export default AuthLayout;